<template>
  <div v-loading="loading">
    <el-form class="form" label-width="110px" ref="ruleForm" :model="form" :rules="rules">
      <el-form-item label="房间号：" prop="roomId">
        <el-input v-model="form.roomId" placeholder="输入 all 可以解散所有房间" />
      </el-form-item>
      <el-form-item label="牌局类型：">
        <el-select v-model="form.roomPath">
          <el-option
            v-for="item of roomPathOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="解散类型：">
        <el-select v-model="form.closeType">
          <el-option
            v-for="item of closeTypeOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="谷歌验证码：" prop="code">
        <el-input v-model="form.code" class="block" placeholder="请输入"> </el-input>
      </el-form-item>
      <div class="footer">
        <el-button type="primary" @click="submitForm('ruleForm')">解散</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { roomPathOptions } from 'mixins';

export default {
  mixins: [roomPathOptions],
  data() {
    return {
      loading: false,
      closeTypeOptions: [
        { label: '停服解散', value: '1' },
        { label: '强制解散', value: '2' },
      ],
      areaOptions: [{ label: '中国', value: 'cn' }],
      form: {
        roomId: '',
        roomPath: '61',
        closeType: '1',
        code: '',
      },
      rules: {
        roomId: [{ required: true, message: '请输入房间号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    };
  },
  methods: {
    ...mapActions('other', ['sendCodeToMyPhone']),
    ...mapActions('system', ['closeRoom']),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.closeRoom(this.form).then(() => {
            this.loading = false;
            this.$message.success('请求成功');
            this.$refs[formName].resetFields();
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  :global(.el-select) {
    width: 100%;
  }
}

.footer {
  padding: 20px 0 0 100px;
  text-align: center;
  :global(.el-button) {
    width: 150px;
  }
}
</style>
